import React from 'react';

const CollectCallInformation = (
  <>
    <p>Collect call accounts are on a prepayment basis and you must maintain a positive credit balance to keep your line open. Any calls received that exceed account balance will be billed to your account and due immediately.</p>
    <p>Payments to your collect call account can be made online or over the phone by calling 1-800-896-3201. No fees apply to the purchase, and it is refundable. Live representatives are available Monday-Friday 8am to 6pm CST. </p>
    <p>Reliance Telephone collect call costs are as follows:</p>
    <p className="font-weight-bold mb-0"><u>Cost of voice calls</u></p>
      <p><b>In State</b>  $0.09 - $0.25/minute + applicable taxes + Telecommunications Relay Service Fund + FCC Rate Additive (Rates vary depending on facility)</p>
      <p><b>State to State</b>  $0.09 - $0.21/minute + applicable taxes + Federal Universal Service Fund + Telecommunications Relay Service Fund + FCC Rate Additive (Rates vary depending on facility) </p>
      <p><b>International</b>  $0.21 - $0.80/minute + applicable taxes + Federal Universal Service Fund + Telecommunications Relay Service Fund + FCC Rate Additive (Rates vary depending on facility) </p>

  </>
)

export default CollectCallInformation;
